import React from 'react';
import AlertModal from "../basic/AlertModal";
import {useNavigate} from "react-router-dom";

function BtnsCreateFixed({create, update, cancel, remove}) {
    const navigate = useNavigate();

    return (
        <div className=" flex gap-3">
            {create &&
                <AlertModal
                    triggerName={"저장"} handler={create}
                    triggerClassName={"save-btn ml-auto"} actionName={"확인"}
                    title={"등록 하시겠습니까?"}
                />
            }
            {update &&

                <AlertModal
                    triggerName={"수정"} handler={update}
                    triggerClassName={"save-btn ml-auto"} actionName={"확인"}
                    title={"수정을 완료합니다."}
                />
            }
            {remove &&
                <AlertModal
                    triggerName={"삭제"} handler={remove}
                    triggerClassName={"save-btn ml-auto"} actionName={"확인"}
                    title={"삭제 하시겠습니까?"}
                />
            }
            {cancel &&
                <AlertModal
                    triggerName={"목록"} handler={()=>navigate(cancel.url, {
                        state: {test : cancel.state}
                })}
                    triggerClassName={"list-btn"} actionName={"확인"}
                    title={"목록으로 돌아가시겠습니까?"}
                    description={"입력한 내용이 모두 취소됩니다."}
                />
            }
            
        </div>
    );
}

export default BtnsCreateFixed;